import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-dialog-title-pre"
}
const _hoisted_2 = { class: "p-dialog-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Title = _resolveComponent("Title")!
  const _component_PrimeDialog = _resolveComponent("PrimeDialog")!

  return (_openBlock(), _createBlock(_component_PrimeDialog, {
    visible: _ctx.visible,
    style: { width: '620px' },
    class: "p-dialog--base p-dialog--prompt",
    closable: true,
    draggable: false,
    modal: true,
    onShow: _ctx.onShow
  }, {
    header: _withCtx(() => [
      (_ctx.closable)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-times",
            class: "p-button-rounded p-button-text dialog-close",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.$slots.beforeHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "beforeHeader")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    _: 3
  }, 8, ["visible", "onShow"]))
}